import { Avatar } from "@molecules";
import { H4, P, Subtitle } from "@quarks";
import { cn } from "@utils";
import { PersonLike } from "@lib/infrastructure";

type Props = {
  member: PersonLike;
  onPress?: () => void;
  disabledReason?: string | null;
  className?: string;
};

export const GroupMemberSelectorItem = ({ member, onPress, disabledReason, className }: Props) => {
  return (
    <div
      className={cn(
        `grid grid-cols-[auto_1fr_auto] gap-x-4 items-center w-full py-2 text-left cursor-pointer hover:bg-gray-50`,
        { "opacity-50 cursor-not-allowed": disabledReason },
        className,
      )}
      onClick={!disabledReason ? onPress : undefined}>
      <Avatar
        size="large"
        user={{ ...member, initials: member.initials || "" }}
      />

      <div className="grid min-w-0">
        <div className="flex justify-between items-center min-w-0">
          <H4 className="truncate min-w-0 flex-1">{member.name || member.email}</H4>
          {disabledReason && <P className="truncate ml-2 min-w-0 flex-shrink-0">{disabledReason}</P>}
        </div>
        <Subtitle className="text-sm truncate min-w-0">{member.email}</Subtitle>
      </div>
    </div>
  );
};
